/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VendorErrorState = {
    EventStateUnknown: 'EVENT_STATE_UNKNOWN',
    Connected: 'CONNECTED',
    Disconnected: 'DISCONNECTED',
    Offline: 'OFFLINE',
    Reconnecting: 'RECONNECTING',
    Paused: 'PAUSED',
    On: 'ON',
    Off: 'OFF',
    Standby: 'STANDBY',
    Booting: 'BOOTING',
    Shutdown: 'SHUTDOWN',
    Idle: 'IDLE',
    Faulted: 'FAULTED',
    Available: 'AVAILABLE',
    Unavailable: 'UNAVAILABLE',
    Preparing: 'PREPARING',
    Finished: 'FINISHED',
    Cancelled: 'CANCELLED',
    Timeout: 'TIMEOUT',
    Locked: 'LOCKED',
    Unlocked: 'UNLOCKED',
    Jammed: 'JAMMED',
    InvalidCode: 'INVALID_CODE',
    Authorized: 'AUTHORIZED',
    Unauthorized: 'UNAUTHORIZED',
    Rejected: 'REJECTED',
    Reserved: 'RESERVED',
    AccessRevoked: 'ACCESS_REVOKED',
    Compromised: 'COMPROMISED',
    Quarantined: 'QUARANTINED',
    Open: 'OPEN',
    Closed: 'CLOSED',
    PartiallyOpen: 'PARTIALLY_OPEN',
    ForcedOpen: 'FORCED_OPEN',
    Stuck: 'STUCK',
    Normal: 'NORMAL',
    Tripped: 'TRIPPED',
    Cleared: 'CLEARED',
    Tampered: 'TAMPERED',
    Detected: 'DETECTED',
    Stationary: 'STATIONARY',
    Empty: 'EMPTY',
    Occupied: 'OCCUPIED',
    Healthy: 'HEALTHY',
    Warning: 'WARNING',
    Error: 'ERROR',
    CriticalFail: 'CRITICAL_FAIL',
    Broken: 'BROKEN',
    Provisioning: 'PROVISIONING',
    Commissioning: 'COMMISSIONING',
    Decommissioned: 'DECOMMISSIONED',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Vibrating: 'VIBRATING',
    Tilted: 'TILTED',
    Auto: 'AUTO',
    ManualOverride: 'MANUAL_OVERRIDE',
    Scheduled: 'SCHEDULED',
    Queued: 'QUEUED',
    Pending: 'PENDING',
    Charging: 'CHARGING',
    Discharging: 'DISCHARGING',
    LowBattery: 'LOW_BATTERY',
    Dead: 'DEAD',
    Flowing: 'FLOWING',
    Leaking: 'LEAKING',
    Blocked: 'BLOCKED',
    Draining: 'DRAINING',
    Filling: 'FILLING',
    Pressurizing: 'PRESSURIZING',
    Heating: 'HEATING',
    Cooling: 'COOLING',
    Defrosting: 'DEFROSTING',
    Ventilating: 'VENTILATING',
    Recirculating: 'RECIRCULATING',
    High: 'HIGH',
    Low: 'LOW',
    Expired: 'EXPIRED',
    Failure: 'FAILURE',
    SuspendedEv: 'SUSPENDED_EV',
    SuspendedEvse: 'SUSPENDED_EVSE',
    Finishing: 'FINISHING',
    EvConnected: 'EV_CONNECTED',
    ConcurrentTx: 'CONCURRENT_TX',
    NoCredit: 'NO_CREDIT',
    NotAllowedTypeEvse: 'NOT_ALLOWED_TYPE_EVSE',
    NotAtThisLocation: 'NOT_AT_THIS_LOCATION',
    NotAtThisTime: 'NOT_AT_THIS_TIME',
    Accepted: 'ACCEPTED',
    NotSupported: 'NOT_SUPPORTED',
    UnknownMessageId: 'UNKNOWN_MESSAGE_ID',
    UnknownVendorId: 'UNKNOWN_VENDOR_ID',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Starting: 'STARTING'
} as const;
export type VendorErrorState = typeof VendorErrorState[keyof typeof VendorErrorState];


export function instanceOfVendorErrorState(value: any): boolean {
    for (const key in VendorErrorState) {
        if (Object.prototype.hasOwnProperty.call(VendorErrorState, key)) {
            if (VendorErrorState[key as keyof typeof VendorErrorState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorErrorStateFromJSON(json: any): VendorErrorState {
    return VendorErrorStateFromJSONTyped(json, false);
}

export function VendorErrorStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorState {
    return json as VendorErrorState;
}

export function VendorErrorStateToJSON(value?: VendorErrorState | null): any {
    return value as any;
}

export function VendorErrorStateToJSONTyped(value: any, ignoreDiscriminator: boolean): VendorErrorState {
    return value as VendorErrorState;
}

